import { render, staticRenderFns } from "./CriticismHandlingModal.vue?vue&type=template&id=125aa115&"
import script from "./CriticismHandlingModal.vue?vue&type=script&lang=js&"
export * from "./CriticismHandlingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports